import type { SearchData } from '@silvertours/common-landingpages-view';

const makeIslandSearchData = (query: string, cityCode?: string): SearchData =>
  ({
    location: {
      cityCode,
      displayName: query,
      type: 'city',
      query,
    },
    prefilterQuery: '',
    type: 'legacy',
  }) as SearchData;

export const ISLAND_STAGE_SEARCH_DATA: Record<string, SearchData> = {
  'mietwagen-mallorca': makeIslandSearchData(
    'Palma de Mallorca alle Stationen',
    'PMI',
  ),
  'mietwagen-kreta': makeIslandSearchData('Iraklion alle Stationen', 'HER'),
  'mietwagen-madeira': makeIslandSearchData('Funchal alle Stationen', 'FNC'),
  'mietwagen-fuerteventura': makeIslandSearchData(
    'Fuerteventura alle Stationen',
    'FUE',
  ),
  'mietwagen-sardinien': makeIslandSearchData('Olbia alle Stationen', 'OLB'),
  'mietwagen-teneriffa': makeIslandSearchData('Flughafen Teneriffa Süd', 'TFS'),
  'mietwagen-gran-canaria': makeIslandSearchData(
    'Las Palmas alle Stationen',
    'LPA',
  ),
  'mietwagen-rhodos': makeIslandSearchData('Rhodos alle Stationen', 'RHO'),
  'mietwagen-korfu': makeIslandSearchData('Corfu alle Stationen', 'CFU'),
  'mietwagen-sizilien': makeIslandSearchData('Catania alle Stationen', 'CTA'),
  'mietwagen-lanzarote': makeIslandSearchData('Arrecife alle Stationen', 'ACE'),
  'mietwagen-ibiza': makeIslandSearchData('Ibiza-Stadt alle Stationen', 'IBZ'),
  'mietwagen-kos': makeIslandSearchData('Kos alle Stationen', 'KGS'),
  'mietwagen-zakynthos': makeIslandSearchData(
    'Zakynthos alle Stationen',
    'ZTH',
  ),
  'mietwagen-korsika': makeIslandSearchData('Flughafen Bastia', 'BIA'),
  'mietwagen-la-palma': makeIslandSearchData(
    'Santa Cruz de la Palma alle Stationen',
    'SPC',
  ),
  'mietwagen-sylt': makeIslandSearchData('Westerland alle Stationen', 'GWT'),
  'mietwagen-menorca': makeIslandSearchData('Mahon alle Stationen', 'MAH'),
  'mietwagen-la-gomera': makeIslandSearchData(
    'San Sebastian/ La Gomera alle Stationen',
    'GMZ',
  ),
  'mietwagen-santorini': makeIslandSearchData(
    'Santorini alle Stationen',
    'JTR',
  ),
  'mietwagen-bali': makeIslandSearchData('Denpasar-Bali alle Stationen', 'DPS'),
  'mietwagen-naxos': makeIslandSearchData('Naxos alle Stationen', 'JNX'),
  'mietwagen-formentera': makeIslandSearchData('Formentera', '0014Z'),
  'mietwagen-samos': makeIslandSearchData('Samos alle Stationen', 'SMI'),
  'mietwagen-koh-samui': makeIslandSearchData(
    'Koh Samui alle Stationen',
    'USM',
  ),
  'mietwagen-thassos': makeIslandSearchData('Thasos', '0007T'),
  'mietwagen-mykonos': makeIslandSearchData('Mykonos alle Stationen', 'JMK'),
  'mietwagen-ruegen': makeIslandSearchData('Bergen auf Rügen', '0032H'),
  'mietwagen-elba': makeIslandSearchData('Elba', 'EBA'),
  'mietwagen-usedom': makeIslandSearchData('Heringsdorf alle Stationen', 'HDF'),
  'mietwagen-paros': makeIslandSearchData('Paros alle Stationen', 'PAS'),
  'mietwagen-mahe': makeIslandSearchData('Flughafen Mahe', 'SEZ'),
  'mietwagen-fehmarn': makeIslandSearchData('Fehmarn', '001BH'),
  'mietwagen-milos': makeIslandSearchData('Milos alle Stationen', 'MLO'),
  'mietwagen-karpathos': makeIslandSearchData(
    'Karpathos alle Stationen',
    'AOK',
  ),
  'mietwagen-djerba': makeIslandSearchData('Djerba alle Stationen', 'DJE'),
  'mietwagen-pico': makeIslandSearchData('Pico Island alle Stationen', 'PIX'),
  'mietwagen-el-hierro': makeIslandSearchData(
    'Flughafen El hierro (Valverde Hierro)',
    'VDE',
  ),
  'mietwagen-vancouver-island': makeIslandSearchData(
    'Flughafen Victoria (YYJ)',
    'YYJ',
  ),
  'mietwagen-bornholm': makeIslandSearchData(
    'Roenne - Bornholm alle Stationen',
    'RNN',
  ),
  'mietwagen-skopelos': makeIslandSearchData('Skopelos', '0007S'),
  'mietwagen-lesbos': makeIslandSearchData(
    'Lesbos/Mytilene alle Stationen',
    'MJT',
  ),
  'mietwagen-langkawi': makeIslandSearchData('Langkawi alle Stationen', 'LGK'),
  'mietwagen-syrakus': makeIslandSearchData('Syracuse alle Stationen', 'CIY'),
  'mietwagen-oahu': makeIslandSearchData('Oahu', 'HNL'),
  'mietwagen-sifnos': makeIslandSearchData('Sifnos', '008BB'),
  'mietwagen-tinos': makeIslandSearchData('Tinos', '0030L'),
  'mietwagen-cala-mandia': makeIslandSearchData('Cala Mandia', '002ES'),
  'mietwagen-chios': makeIslandSearchData('Chios alle Stationen', 'JKH'),
  'mietwagen-flores': makeIslandSearchData('Flores alle Stationen', 'FLW'),
  'mietwagen-syros': makeIslandSearchData('Syros alle Stationen', 'JSY'),
  'mietwagen-cozumel': makeIslandSearchData('Cozumel alle Stationen', 'CZM'),
  'mietwagen-poros': makeIslandSearchData('Poros', '003DC'),
  'mietwagen-neufundland': makeIslandSearchData(
    'St. Johns alle Stationen',
    'YYT',
  ),
  'mietwagen-kythira': makeIslandSearchData('Kithira alle Stationen', 'KIT'),
  'mietwagen-kauai-island': makeIslandSearchData(
    'Kauai Island alle Stationen',
    'LIH',
  ),
};

export const ISLAND_PAGE_PATHS = Object.keys(ISLAND_STAGE_SEARCH_DATA).map(
  slug => `/${slug}.html`,
) as readonly string[];
